import { useEffect } from "react";
import { CalcSteps } from "@/components/calc/CalcSteps";
import { ExportBar } from "@/components/calc/ExportBar";
import { CalcHistory } from "@/components/calc/CalcHistory";
import { recordCalculation, useCalcHistory } from "@/lib/calc/history";
import { stepsToText, type CalcStep } from "@/lib/calc/steps";
import { toCsv } from "@/lib/csv";

/**
 * Under the Percentage Calculator's result: the worked steps, the last 10 calculations of this visit (memory only) and the gated export bar.
 * Loaded on demand (React.lazy).
 */
export default function PercentageExtras({ summary, steps, gate }: { summary: string; steps: CalcStep[]; gate: () => Promise<boolean> }) {
  useEffect(() => {
    if (!summary) return;
    const t = setTimeout(() => recordCalculation("percentage-calculator", summary), 800);
    return () => clearTimeout(t);
  }, [summary]);
  const history = useCalcHistory().filter((e) => e.tool === "percentage-calculator");
  const text = [summary, "", "Working", stepsToText(steps), ...(history.length ? ["", "This visit", ...history.map((h) => h.summary)] : []), "", "Calculated with FreeDailyPro.com"].join("\n");
  const csv = toCsv(history.map((h, i) => ({ n: i + 1, calc: h.summary })), [{ key: "n", header: "#" }, { key: "calc", header: "Calculation" }]);
  return (
    <div className="mt-6 space-y-4">
      <CalcSteps steps={steps} title="Worked steps" />
      <ExportBar gate={gate} text={text} csv={csv} filename="percentage-calculations.csv" label="working and history" />
      <CalcHistory tool="percentage-calculator" />
    </div>
  );
}
